// Converts a cropper canvas into a size-limited data URL for the cart.
export function canvasToDataUrl(canvas, { maxSize = 1200, type, quality }) {
    if (!canvas) {
        return null;
    }
    const scale = Math.min(1, maxSize / Math.max(canvas.width, canvas.height));
    let output = canvas;
    if (scale < 1) {
        output = document.createElement("canvas");
        output.width = Math.round(canvas.width * scale);
        output.height = Math.round(canvas.height * scale);
        output
            .getContext("2d")
            .drawImage(canvas, 0, 0, output.width, output.height);
    }
    return output.toDataURL(type, quality);
}

export function debounce(fn, wait) {
    let timer = null;
    const debounced = function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), wait);
    };
    debounced.cancel = () => clearTimeout(timer);
    return debounced;
}
